import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface ConfirmDialogMessage {
  center: string;
  date: {
    month: number;
    year: number;
  };
}

@Component({
  selector: 'bav-reporting-ui-common-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
})
export class ConfirmDialogComponent {
  confirmData?: ConfirmDialogMessage;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: ConfirmDialogMessage | undefined,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
  ) {
    this.confirmData = data;
  }

  onConfirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
